// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"clinical-portal-3__StatusIndicator__wrapper","errorPanel":"clinical-portal-3__StatusIndicator__errorPanel"};